import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FcHorizontalBarChartComponent } from './fc-horizontal-bar-chart.component';

@NgModule({
  declarations: [FcHorizontalBarChartComponent],
  imports: [
    CommonModule,
    NgxChartsModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    TranslateModule
  ],
  exports: [
    FcHorizontalBarChartComponent
  ]
})
export class FcHorizontalBarChartModule { }
